import { Currency, formatMoney, OrderCriteria } from '@nemuru-eng/js-api-client';

import { Text } from '@/components/shared/components/Text';

export const orderPrincipalFieldColumn = ({ flex }: { flex?: number }) => {
  return {
    flex: flex ?? 0.28,
    field: 'order_value_value',
    sortable: false,
    align: 'right',
    type: 'number',
    headerName: (
      <div style={{ textAlign: 'right' }}>
        <Text tId={'PRINCIPAL'} />
      </div>
    ),
    renderCell: (rowData: { row: OrderCriteria }) => (
      <div
        className={'overflow-text-ellipsis'}
        style={{
          display: 'flex',
          alignItems: 'center',
          lineHeight: '1.43',
        }}
      >
        {rowData.row.loan.principal &&
          formatMoney(
            {
              value: rowData.row.loan.principal.amount,
              currency: rowData.row.loan.principal.currency as Currency,
            },
            2,
          )}
      </div>
    ),
  };
};
